import React from 'react';
import { FormattedMessage } from 'react-intl';
import ChairOutlined from 'dibs-vg/dist/react/chair-outlined';
import style from './FavNotificationsEmpty-style.scss';

const FavNotificationsEmpty = () => (
    <div className={style.container}>
        <ChairOutlined className={style.icon} />
        <div className={style.favoritesHeader}>
            <FormattedMessage
                id='dbl.Header.FavNotificationsEmpty.favorites_header'
                defaultMessage='See something you like?'
            />
        </div>
        <div className={style.text}>
            <FormattedMessage
                id='dbl.Header.FavNotificationsEmpty.favorites_text'
                defaultMessage='Save items you love for updates on their status! Click the heart icon next to them.'
            />
        </div>
        <div className={style.line} />
        <div className={style.followHeader}>
            <FormattedMessage
                id='dbl.Header.FavNotificationsEmpty.following_header'
                defaultMessage='Never miss out'
            />
        </div>
        <div className={style.text}>
            <FormattedMessage
                id='dbl.Header.FavNotificationsEmpty.following_text'
                defaultMessage='Follow categories, dealers, and interior designers to see new additions!'
            />
        </div>
        <a href='/'>
            <FormattedMessage
                id='dbl.Header.FavNotificationsEmpty.link_text'
                defaultMessage='Learn more'
            />
        </a>
    </div>
);

export default FavNotificationsEmpty;



// WEBPACK FOOTER //
// ./src/components/FavNotifications/FavNotificationsEmpty.jsx